module.exports = __webpack_public_path__ + "img/ep3-2-1.9e0cb1fb.png";